export class StoreImportModel {
    counter: number = 0;
    branchCode: number = 0;
    code: number = 0;
    alterCode: string | null = null;
    name: string = "";
    costCenterCode: string | null = null;
    inventoryCode: number = 0;
    isActive: boolean = false;
    isOwned: boolean = false;
    occupancyPercentage: boolean = false;

    constructor(
        counter: number = 0,
        branchCode: number = 0,
        code: number = 0,
        alterCode: string | null = null,
        name: string = "",
        costCenterCode: string | null = null,
        inventoryCode: number = 0,
        isActive: boolean = false,
        isOwned: boolean = false,
        occupancyPercentage: boolean = false,
    ) {
        this.counter = counter;
        this.branchCode = branchCode;
        this.code = code;
        this.alterCode = alterCode;
        this.name = name;
        this.costCenterCode = costCenterCode;
        this.inventoryCode = inventoryCode;
        this.isActive = isActive;
        this.isOwned = isOwned;
        this.occupancyPercentage = occupancyPercentage;
    }
}
